// APi接口进行统一管理
import requests from "./request";
let url = 'http://119.27.170.129:58084/api'
// 登录接口
export const Login = (params) =>
    // 发请求 axios发请求返回的是promise对象
    requests({ url: url + '/ycshop/checkLogin', method: 'post', data: params })

// 获取用户基本信息 
export const getUserInfo = (params) =>
    requests({ url: url + '/ycshop/getcustinfo', method: 'post', data: params })

// 商品材质列表、品牌列表
export const getcomlist = (params) =>
    requests({ url: url + '/ycshop/getcomlist', method: 'post', data: params })

// 获取左边菜单列表 
export const getMenuList = (params) =>
    requests({ url: url + '/ycshop/Getmenulist', method: 'post', data: params })


// 获取右边商品列表
export const getTypeList = (params) =>
    requests({ url: url + '/ycshop/GetptypeList', method: 'post', data: params })

// 获取订单列表
export const getBillList = (params) =>
    requests({ url: url + '/ycshop/getbilllist', method: 'post', data: params })


// 获取关于我们
export const getAboutus = (params) =>
    requests({ url: url + '/ycshop/getaboutus', method: 'post', data: params })

// 修改密码
export const changepwd = (params) =>
    requests({ url: url + '/ycshop/changepwd', method: 'post', data: params })


// 登出
export const loginout = (params) =>
    requests({ url: url + '/ycshop/loginout', method: 'post', data: params })

// 获取收货地址列表
export const getshaddress = (params) =>
    requests({ url: url + '/ycshop/getshaddress', method: 'post', data: params })

// 删除订单
export const delbill = (params) =>
    requests({ url: url + '/ycshop/delbill', method: 'post', data: params })

// 保存用户信息
export const saveuserinfo = (params) =>
    requests({ url: url + '/ycshop/saveuserinfo', method: 'post', data: params })

// 保存增值税开票信息
export const savetaxinfo = (params) =>
    requests({ url: url + '/ycshop/savetaxinfo', method: 'post', data: params })

// 获取订单商品明细
export const getbilldetail = (params) =>
    requests({ url: url + '/ycshop/getbilldetail', method: 'post', data: params })

// 保存收货地址信息
export const saveshinfo = (params) =>
    requests({ url: url + '/ycshop/saveshinfo', method: 'post', data: params })

// 支付确认按钮
export const chenkpaybill = (params) =>
    requests({ url: url + '/ycshop/chenkpaybill', method: 'post', data: params })

// 保存订单
export const saveorderbill = (params) =>
    requests({ url: url + '/ycshop/saveorderbill', method: 'post', data: params })

// 获得物流公司列表
export const getwuliulist = (params) =>
    requests({ url: url + '/ycshop/getwuliulist', method: 'post', data: params })

// 文件上传
export const UpLoadFile = (params) =>
    requests({ url: url + '/ycshop/UpLoadFile', method: 'post', data: params })

// 新闻保存
export const savenewsinfo = (params) =>
    requests({ url: url + '/ycshop/savenewsinfo', method: 'post', data: params })


// 获得新闻列表
export const getnewsinfo = (params) =>
    requests({ url: url + '/ycshop/getnewsinfo', method: 'post', data: params })

// 新闻删除
export const delnewsinfo = (params) =>
    requests({ url: url + '/ycshop/delnewsinfo', method: 'post', data: params })

// 获得订单主表信息
export const getorderbill = (params) =>
    requests({ url: url + '/ycshop/getorderbill', method: 'post', data: params })

// 计算快递运费
export const computkdmoney = (params) =>
    requests({ url: url + '/ycshop/computkdmoney', method: 'post', data: params })

// 获取物流信息
export const getprogress = (params) =>
    requests({ url: url + '/ycshop/getprogress', method: 'post', data: params })